import React from 'react';
import Styles from './RenaultLogan.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import {cars} from './Data';
import Hero from '../HeroForm/Hero';

const RenaultLogan = () => {
  return (
   
     <div className={Styles.main_page}>
     <h2>Renault Logan</h2>
     {/*Carousel*/}
     <div className={Styles.car_image}>
       <Carousel images={cars} />
     </div>
      <Hero selectedCar="Renault Logan" /> 
   </div>
  );
}

export default RenaultLogan;
